/**
 * @name THEME_COLOR_NAMES
 * @description color names
 */
export const THEME_COLOR_NAMES = {
  COMMON: 'common',
  BLACK: 'black',
  WHITE: 'white',
  PRIMARY: 'primary', // blue
  SECONDARY: 'secondary', // green
  GREY: 'grey',
  PURPLE: 'purple',
  MAGENTA: 'pink',
  ORANGE: 'orange',
  YELLOW: 'egg',
};

/**
 * @name THEME_COLOR_TYPE_NAMES
 * @description particular color types
 */
export const THEME_COLOR_TYPE_NAMES = {
  BRAND: 'brand',
  BLACK: 'black',
  WHITE: 'white',
};

/**
 * @name THEME_COLOR_SHADE_NAMES
 * @description color shades
 */
export const THEME_COLOR_SHADE_NAMES = {
  MAIN: 'main',
  LIGHT: 'light',
  DARK: 'dark',
};
